import React from "react";
import PufframaBannerImage from "../../assets/img/Pufframa-Banner.png";

const PufframaBanner = () => {
  return (
    <section className="w-full overflow-hidden">
      <img
        src={PufframaBannerImage}
        alt="Pufframa Banner"
        className="block h-auto w-full object-cover"
      />
    </section>
  );
};

export default PufframaBanner;